import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Icon } from 'antd';

const NewIcrFormNotice = ({ visible, onClose }) => (
  <Modal
    visible={visible}
    onOk={onClose}
    onCancel={onClose}
    okText="Got it"
    cancelButtonProps={{ style: { display: 'none' } }}
    title={(
      <span>
        <Icon type="info-circle" style={{ color: '#1890ff', marginRight: '8px' }} />
        New ICR Beta Form Enabled
      </span>
    )}
  >
    <p>The new ICR beta form is now enabled for your organization.</p>
    <p>
      You can disable it by toggling it off above, or from the <strong>Settings page</strong>.
    </p>
  </Modal>
);

NewIcrFormNotice.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NewIcrFormNotice;
